import { useQuery } from "@tanstack/react-query";
import { adminTrainingKeys } from "@/lib/query";

export type CourseProgressEntry = {
  courseId: string;
  courseTitle: string;
  courseSlug: string;
  started: boolean;
  completedAt: string | null;
};

export type TrainingUser = {
  id: string;
  name: string;
  email: string;
  role: string;
  createdAt: string;
  courseProgress: CourseProgressEntry[];
};

export type TrainingCourse = {
  id: string;
  title: string;
  slug: string;
};

type TrainingData = {
  data: TrainingUser[];
  courses: TrainingCourse[];
};

async function fetchTraining(search: string): Promise<TrainingData> {
  const params = search ? `?search=${encodeURIComponent(search)}` : "";
  const res = await fetch(`/api/admin/training${params}`);
  if (!res.ok) throw new Error("Failed to load training data");
  return (await res.json()) as TrainingData;
}

export function useAdminTraining(search = "") {
  return useQuery({
    queryKey: adminTrainingKeys.list({ search }),
    queryFn: () => fetchTraining(search),
  });
}
